export type StoreToastType = "success" | "error" | "info" | "warning";

type ShowToastFn = (
  message: string,
  type?: StoreToastType,
  duration?: number,
  options?: { variant?: "cart" | "wishlist" }
) => void;

let showToastImpl: ShowToastFn | null = null;

export function registerStoreToast(fn: ShowToastFn) {
  showToastImpl = fn;
}

export function showToastFromStore(
  message: string,
  type: StoreToastType = "warning",
  duration = 5000,
  options?: { variant?: "cart" | "wishlist" }
) {
  showToastImpl?.(message, type, duration, options);
}
